var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5-.5a18,18,0,0,1,7.007,34.585A18,18,0,0,1,10.493.915,17.888,17.888,0,0,1,17.5-.5Zm0,35A17,17,0,0,0,29.521,5.479,17,17,0,1,0,5.479,29.521,16.889,16.889,0,0,0,17.5,34.5Z",
    transform: "translate(2 2)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16.707,11.293,16l4-4-4-4L12,7.293,16.707,12Z",
    transform: "translate(9.375 7.5)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5.5H-.5v-1h10Z",
    transform: "translate(15.5 19.5)",
    fill: "#dfe1e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRightArrow);
export default __webpack_public_path__ + "static/media/carousel-right-arrow.99a1e6493c738254b4eba73981edff93.svg";
export { ForwardRef as ReactComponent };